// =====================================================================
// Analytics helper
// ---------------------------------------------------------------------
// Fires the same event to:
//   1. Google Analytics 4   (window.gtag, configured in public/index.html)
//   2. Your own MongoDB     (POST /api/events) — surfaced in /admin → Stats
// Failures are swallowed silently so analytics can never break the UX.
// =====================================================================

import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

export function trackEvent(type, page = null, meta = null) {
  // Internal stats — fire-and-forget
  try {
    axios
      .post(`${API}/events`, { type, page, meta })
      .catch(() => {});
  } catch {
    /* no-op */
  }

  // Google Analytics 4
  try {
    if (typeof window !== "undefined" && typeof window.gtag === "function") {
      window.gtag("event", type, {
        page_path: page || undefined,
        ...(meta || {}),
      });
    }
  } catch {
    /* no-op */
  }
}

export function trackPageView(path) {
  trackEvent("page_view", path);
  // Also tell GA4 about the SPA navigation so it picks up the new path
  try {
    if (typeof window !== "undefined" && typeof window.gtag === "function") {
      window.gtag("event", "page_view", {
        page_path: path,
        page_location: window.location.href,
      });
    }
  } catch {
    /* no-op */
  }
}
